import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AddMainCompi = () => {
    const navigate = useNavigate();
    const [compi, setCompi] = useState({
        competitionName: null,
        subtitle: null,
        description: null,
        genreId: null,
        rules: null,
        prizesLyp: null,
        isTeamCompi: false,
        maxParticipants: null,
        minParticipants: null,
        submissionDeadline: null,
        isOnline: false,
    });
    const [genres, setGenres] = useState([]);
    const [submitDisabled, setSubmitDisabled] = useState(false);

    const onChange = (e) => {
        setCompi({ ...compi, [e.target.name]: e.target.value });
    };

    const getAllGenres = () => {
        Axios.get("https://ashish.moodi.org/competitions/get_genres")
            .then((res) => setGenres(res.data))
            .catch((err) => console.error(err));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitDisabled(true);
        if (compi.isTeamCompi) {
            compi.maxParticipants = parseInt(compi.maxParticipants);
            compi.minParticipants = parseInt(compi.minParticipants);
        }
        Axios.post(
            "https://ashish.moodi.org/competitions/add_compi",
            {
                competitionName: compi.competitionName,
                subtitle: compi.subtitle,
                description: compi.description,
                genreId: compi.genreId,
                rules: compi.rules,
                prizesLyp: compi.prizesLyp,
                isTeamCompi: compi.isTeamCompi,
                minParticipants: compi.minParticipants,
                maxParticipants: compi.maxParticipants,
                isOnline: compi.isOnline,
                submissionDeadline: compi.submissionDeadline,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                console.log(res.data);
                if (res.data.status == "done") {
                    alert("competition added successfully");
                    setCompi({
                        competitionName: null,
                        subtitle: null,
                        description: null,
                        genreId: null,
                        rules: null,
                        prizesLyp: null,
                        isTeamCompi: false,
                        maxParticipants: null,
                        minParticipants: null,
                        submissionDeadline: null,
                        isOnline: false,
                    });
                    setSubmitDisabled(false);
                    window.location.reload();
                }
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (localStorage.getItem("compiauthtoken")) {
            getAllGenres();
        } else {
            navigate("/admin/login");
        }
    }, []);

    return (
        <div className="container-fluid">
            <form onSubmit={handleSubmit}>
                <div className="my-3">
                    <div className="row">
                        <div className="col-3">
                            <label
                                htmlFor="competitionName"
                                className="form-label"
                            >
                                Competition Name
                            </label>
                        </div>
                        <div className="col-9">
                            <input
                                type="text"
                                className="form-control"
                                id="competitionName"
                                name="competitionName"
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className="mb-3 row">
                    <div className="col-3">
                        <label htmlFor="subtitle" className="form-label">
                            Subtitle
                        </label>
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            id="subtitle"
                            name="subtitle"
                            onChange={onChange}
                            required
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <div className="col-3">
                        <label htmlFor="description" className="form-label">
                            Description
                        </label>
                    </div>
                    <div className="col-9">
                        <input
                            type="text"
                            className="form-control"
                            id="description"
                            name="description"
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <div className="col-2">
                        <label htmlFor="genreId" className="form-label">
                            Genre
                        </label>
                    </div>
                    <div className="col-3">
                        <select
                            name="genreId"
                            id="genreId"
                            placeholder="Select One value"
                            value={compi.genreId}
                            onChange={onChange}
                            required
                        >
                            <option value="" selected>
                                Please select a value
                            </option>
                            {genres.map((genre) => {
                                return (
                                    <option value={genre.genreId}>
                                        {genre.genreName}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div className="form-check col-2">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="isOnline"
                            name="isOnline"
                            onClick={() => {
                                if (compi.isOnline === false) {
                                    setCompi({ ...compi, isOnline: true });
                                } else {
                                    setCompi({ ...compi, isOnline: false });
                                }
                            }}
                        />
                        <label className="form-check-label" htmlFor="isOnline">
                            Online Compi
                        </label>
                    </div>
                    <div className="col-2">
                        <label
                            htmlFor="submissionDeadline"
                            className="form-label"
                        >
                            Submission Deadline
                        </label>
                    </div>
                    <div className="col-3">
                        <input
                            disabled={!compi.isOnline}
                            type="date"
                            name="submissionDeadline"
                            id="submissionDeadline"
                            onChange={onChange}
                            required={!compi.isOnline}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="mb-3 form-check col-3 mx-2">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="isTeamCompi"
                            name="isTeamCompi"
                            onClick={() => {
                                if (compi.isTeamCompi === false) {
                                    setCompi({ ...compi, isTeamCompi: true });
                                } else {
                                    setCompi({ ...compi, isTeamCompi: false });
                                }
                            }}
                            required={compi.isTeamCompi}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="isTeamCompi"
                        >
                            Team Compi
                        </label>
                    </div>
                    <div className="mb-3 col-2">
                        <label htmlFor="minParticipants">
                            Min Participants
                        </label>
                    </div>
                    <div className="mb-3 col-1">
                        <input
                            disabled={!compi.isTeamCompi}
                            type="number"
                            className="form-control"
                            id="minParticipants"
                            name="minParticipants"
                            onChange={onChange}
                            required={compi.isTeamCompi}
                            placeholder="0"
                        />
                    </div>
                    <div className="mb-3 col-2">
                        <label htmlFor="maxParticipants">
                            Max Participants
                        </label>
                    </div>
                    <div className="mb-3 col-1">
                        <input
                            disabled={!compi.isTeamCompi}
                            type="number"
                            className="form-control"
                            id="maxParticipants"
                            name="maxParticipants"
                            onChange={onChange}
                            required={compi.isTeamCompi}
                            placeholder="0"
                        />
                    </div>
                </div>
                <div className="form-floating mb-3">
                    <textarea
                        className="form-control"
                        placeholder="Leave a comment here"
                        id="rules"
                        name="rules"
                        style={{ height: "15vh" }}
                        onChange={onChange}
                    ></textarea>
                    <label htmlFor="rules">Rules</label>
                </div>
                <div className="form-floating mb-3">
                    <textarea
                        className="form-control"
                        placeholder="Leave a comment here"
                        id="prizesLyp"
                        name="prizesLyp"
                        style={{ height: "15vh" }}
                        onChange={onChange}
                    ></textarea>
                    <label htmlFor="prizesLyp">Prizes & LYP</label>
                </div>
                <div className="row px-2">
                    {submitDisabled ? (
                        <button
                            class="btn btn-primary col-auto"
                            type="submit"
                            disabled={submitDisabled}
                        >
                            <span
                                class="spinner-border spinner-border-sm"
                                aria-hidden="true"
                            ></span>
                            <span role="status">Submitting...</span>
                        </button>
                    ) : (
                        <input
                            type="submit"
                            value="Submit"
                            className="btn btn-primary col-auto"
                            disabled={submitDisabled}
                        />
                    )}
                </div>
            </form>
        </div>
    );
};

export default AddMainCompi;
